import React, { useEffect, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import InsertDriveFile from '@material-ui/icons/InsertDriveFile';
import { getCapitoliCount } from '../../../utils/api/capitoli_api.js';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { setChapterIndex, setParagraphIndex } from '../../../utils/storage.js';
import { useTheme } from '@material-ui/core';
import { reportApiError } from '../../../utils/reportApiError';

export default function ModificaModelloManualeButton(props) {
  const [chapters, setChapters] = useState('false');
  const theme = useTheme();
  let history = useHistory();

  const hasChapters = (modello) => {
    getCapitoliCount(modello)
      .then((result) => {
        if (result > 0) {
          setChapters('true');
          setChapterIndex(0);
          setParagraphIndex(0);
          history.push(
            '/amministrazione/manuali/nuovomanuale/' +
              props.modelloId +
              '/modello/' +
              true,
          );
        } else {
          setChapters('false');
          setChapterIndex(0);
          setParagraphIndex(0);
          history.push(
            '/amministrazione/manuali/nuovomanuale/' +
              props.modelloId +
              '/modello/' +
              false,
          );
        }
      })
      .catch((error) => {
        reportApiError(error);
      });
  };
  useEffect(() => {
    //hasChapters(props.modelloId);
  });

  return (
    <IconButton
      size="small"
      disabled={props.disabled}
      style={{
        color: props.disabled
          ? theme.palette.disabled.main
          : theme.palette.primary.main,
      }}
      onClick={() => {
        hasChapters(props.modelloId);
      }}
    >
      <InsertDriveFile />
    </IconButton>
  );
}

ModificaModelloManualeButton.propTypes = {
  modelloId: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};
